module.exports = __webpack_public_path__ + "img/invoicelist-Refund.3de36f1b.png";